import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) =>
	({
		cardContent: {
			// flexGrow: 1,
		},
		title: {
			alignItems: "center",
		},
		container: {
			alignItems: "center",
		},
		stats: {
			flexGrow: 1,
			textAlign: "center",
		},
		stat: {
			
		},
		actions: {
			textAlign: "right",
		},
		actionButtons: {
			marginLeft: 10,
		},
		eee: {
			backgroundColor: "#eee"
		},
		fff: {
			backgroundColor: "#fff"
		},
	} satisfies Record<string, CSSObject>);
